import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-300px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { class: "px-7 py-5" }
const _hoisted_5 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "px-7 py-5" }, [
      _createElementVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Bộ lọc")
    ], -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "separator border-gray-200" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "form-label fw-bold" }, "Tên nhóm quyền:", -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.data.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.name) = $event)),
            placeholder: "Tên nhóm quyền..."
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "separator border-gray-200" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "reset",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args))),
          class: "btn btn-sm btn-white btn-active-light-primary me-2",
          "data-kt-menu-dismiss": "true"
        }, " Đặt lại "),
        _createElementVNode("button", {
          type: "submit",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFindPage && _ctx.handleFindPage(...args))),
          class: "btn btn-sm btn-primary",
          "data-kt-menu-dismiss": "true"
        }, " Tìm kiếm ")
      ])
    ])
  ]))
}